import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import React, { useEffect, useState } from "react";
import { unwrapList, unwrapEntityList } from "../app/helpers/apiEnvelope";
import {
  buildResearchQuery,
  buildIdsQuery,
} from "../app/helpers/researchQuery";

/*****************fetch all Applicants */
const fetchApplicants = async (data) => {
  let Optional = "/";
  let CapitalOrderBy =
    data?.OrderBy.charAt(0).toUpperCase() + data?.OrderBy.slice(1);

  if (data?.search && !data?.OrderBy) {
    Optional = `?search=${data?.search}`;
  } else if (!data?.search && data?.OrderBy) {
    Optional = `?OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  } else if (data?.search && data?.OrderBy) {
    Optional = `?SearchBy=${data?.search}&OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  }

  return await axios.get(
    API_URL +
      `/api/ApplicantView/GetApplicants/${data?.pageSize}/${data?.pageNumber}${Optional}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchApplicants = (data) => {
  return useQuery({
    queryKey: ["applicants"],
    queryFn: () => fetchApplicants(data),
    enabled: true,
  });
};

const fetchSingleApplicant = async (id) => {
  if (id) {
    return await axios.get(
      API_URL + `/api/ApplicantView/GetApplicantById?ApplicantId=${id}`,
      {
        headers: securityHeaders,
      }
    );
  }
};
export const useFetchSingleApplicant = (id) => {
  return useQuery({
    queryKey: ["ApplicantbyId"],
    queryFn: () => fetchSingleApplicant(id),
    enabled: true,
  });
};

/*****************fetch all Leads */
const fetchLeads = async (data) => {
  let Optional = "/";
  let CapitalOrderBy =
    data?.OrderBy.charAt(0).toUpperCase() + data?.OrderBy.slice(1);

  if (data?.search && !data?.OrderBy) {
    Optional = `?search=${data?.search}`;
  } else if (!data?.search && data?.OrderBy) {
    Optional = `?OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  } else if (data?.search && data?.OrderBy) {
    Optional = `?SearchBy=${data?.search}&OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  }

  return await axios.get(
    API_URL +
      `/api/ApplicantView/GetShowingInterest/${data?.pageSize}/${data?.pageNumber}${Optional}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchLeads = (data) => {
  return useQuery({
    queryKey: ["leads"],
    queryFn: () => fetchLeads(data),
    enabled: true,
  });
};

const fetchSingleLead = async (id) => {
  if (id) {
    return await axios.get(
      API_URL + `/api/ApplicantView/GetShowingInterestById/${id}`,
      {
        headers: securityHeaders,
      }
    );
  }
};
export const useFetchSingleLead = (id) => {
  return useQuery({
    queryKey: ["LeadbyId"],
    queryFn: () => fetchSingleLead(id),
    enabled: true,
  });
};
/*****************fetch all Scholarship */
const fetchScholarship = async (data) => {
  let Optional = "/";
  let CapitalOrderBy =
    data?.OrderBy.charAt(0).toUpperCase() + data?.OrderBy.slice(1);

  if (data?.search && !data?.OrderBy) {
    Optional = `?search=${data?.search}`;
  } else if (!data?.search && data?.OrderBy) {
    Optional = `?OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  } else if (data?.search && data?.OrderBy) {
    Optional = `?SearchBy=${data?.search}&OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  }

  return await axios.get(
    API_URL +
      `/api/Scholarship/GetScholarshipApplication/${data?.pageSize}/${data?.pageNumber}${Optional}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchScholarship = (data) => {
  return useQuery({
    queryKey: ["Scholarship"],
    queryFn: () => fetchScholarship(data),
    enabled: true,
  });
};

const fetchSingleScholarship = async (id) => {
  if (id) {
    return await axios.get(
      API_URL + `/api/Scholarship/GetScholarshipApplicationById/${id}`,
      {
        headers: securityHeaders,
      }
    );
  }
};
export const useFetchSingleScholarship = (id) => {
  return useQuery({
    queryKey: ["ScholarshipbyId", id],
    queryFn: () => fetchSingleScholarship(id),
    enabled: true,
  });
};

/*****************fetch all Facility */
const fetchFacility = async (data) => {
  let Optional = "/";
  let CapitalOrderBy =
    data?.OrderBy.charAt(0).toUpperCase() + data?.OrderBy.slice(1);

  if (data?.search && !data?.OrderBy) {
    Optional = `?search=${data?.search}`;
  } else if (!data?.search && data?.OrderBy) {
    Optional = `?OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  } else if (data?.search && data?.OrderBy) {
    Optional = `?SearchBy=${data?.search}&OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  }

  return await axios.get(
    API_URL +
      `/api/Facility/GetFacilities/${data?.pageSize}/${data?.pageNumber}${Optional}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchFacility = (data) => {
  return useQuery({
    queryKey: ["facility"],
    queryFn: () => fetchFacility(data),
    enabled: true,
  });
};

const fetchSingleFacility = async (id) => {
  if (id) {
    return await axios.get(API_URL + `/api/Facility/GetFacilitiesById/${id}`, {
      headers: securityHeaders,
    });
  }
};
export const useFetchSingleFacility = (id) => {
  return useQuery({
    queryKey: ["FacilitybyId", id],
    queryFn: () => fetchSingleFacility(id),
    enabled: true,
  });
};
/*****************fetch all Research */
const fetchResearch = async (data) => {
  const query = buildResearchQuery(data?.filters);

  return await axios.get(
    API_URL +
      `/api/Research/Research/${data?.pageSize}/${data?.pageNumber}${query}`,
    {
      headers: securityHeaders,
    }
  );
};

/**
 * `select` normalises the body BEFORE any screen sees it, so `research.data`
 * keeps meaning "the list payload" whether or not the controller wraps its
 * response in the contract envelope. Without this the whole table renders its
 * headers and no rows the day the backend adds the envelope — a 200 with data
 * in it and an empty screen.
 */
/**
 * THE KEY IS THE REQUEST, which it was not.
 *
 * This read `queryKey: ["research"]` — one constant string. Two consequences,
 * both of them live on the registry screen:
 *
 *  1. The table (10 rows) and the hidden print set (10,000 rows) call this
 *     hook on the same screen, so BOTH wrote to one cache entry. Whichever
 *     resolved last won, and the table could end up rendering the print set's
 *     payload.
 *  2. Changing a filter did not change the key, so nothing refetched on its
 *     own. The page compensated with a `useEffect` calling `refetch()` — which
 *     meant every filter change fired the request twice, once per hook, on top
 *     of the per-keystroke requests the year boxes were already sending.
 *
 * Keying on the page coordinates AND the built query string fixes both: the
 * two queries are now separate entries, and a filter change refetches by
 * itself. The query string is used rather than the filter object because it is
 * a stable primitive — an object literal is a new reference every render and
 * would refetch forever.
 *
 * `keepPreviousData` holds the previous page on screen while the next one
 * loads. Without it every committed filter blanked the table to a spinner and
 * back, which is what made the screen feel like it was thrashing. (This file
 * imports react-query v3 — `@tanstack/react-query` v5 is also installed and
 * spells the same thing `placeholderData: keepPreviousData`. v3's option name
 * is the one that applies here.)
 */
export const useFetchResearch = (data) => {
  const query = buildResearchQuery(data?.filters);

  return useQuery({
    queryKey: ["research", data?.pageSize, data?.pageNumber, query],
    queryFn: () => fetchResearch(data),
    select: (res) => ({ ...res, data: unwrapList(res?.data) }),
    keepPreviousData: true,
    enabled: true,
  });
};

const fetchSingleResearch = async (id) => {
  if (id) {
    return await axios.get(API_URL + `/api/Research/ResearchDetails/${id}`, {
      headers: securityHeaders,
    });
  }
};
export const useFetchSingleResearch = (id) => {
  return useQuery({
    queryKey: ["ResearchbyId", id],
    queryFn: () => fetchSingleResearch(id),
    // The detail screen reads `data[0]`; this keeps that true whether the
    // endpoint answers with an array, a bare entity, or either inside the
    // envelope.
    select: (res) => ({ ...res, data: unwrapEntityList(res?.data) }),
    enabled: true,
  });
};

const fetchResearchDocuments = async (id) => {
  if (id) {
    return await axios.get(API_URL + `/api/Research/Research/${id}`, {
      headers: securityHeaders,
    });
  }
};
export const useFetchResearchDocuments = (id) => {
  return useQuery({
    queryKey: ["researchDocuments", id],
    queryFn: () => fetchResearchDocuments(id),
    select: (res) => ({ ...res, data: unwrapEntityList(res?.data) }),
    enabled: true,
  });
};
//******************** */

/*****************fetch all Applicants */
const fetchQuizzes = async (data) => {
  let Optional = "/";
  let CapitalOrderBy =
    data?.OrderBy.charAt(0).toUpperCase() + data?.OrderBy.slice(1);

  if (data?.search && !data?.OrderBy) {
    Optional = `?search=${data?.search}`;
  } else if (!data?.search && data?.OrderBy) {
    Optional = `?OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  } else if (data?.search && data?.OrderBy) {
    Optional = `?SearchBy=${data?.search}&OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  }

  return await axios.get(
    API_URL +
      `/api/Quiz/GetQuizResults/${data?.pageSize}/${data?.pageNumber}${Optional}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchQuizzes = (data) => {
  return useQuery({
    queryKey: ["quizzes"],
    queryFn: () => fetchQuizzes(data),
    enabled: true,
  });
};

const fetchSingleQuiz = async (id) => {
  if (id) {
    return await axios.get(API_URL + `/api/Quiz/GetQuizResultsById/${id}`, {
      headers: securityHeaders,
    });
  }
};
export const useFetchSingleQuiz = (id) => {
  return useQuery({
    queryKey: ["QuizbyId"],
    queryFn: () => fetchSingleQuiz(id),
    enabled: true,
  });
};

/***********Export table Applicants */

/*****************fetch all Applicants */
const fetchHappinessMeter = async (data) => {
  let Optional = "/";
  let CapitalOrderBy =
    data?.OrderBy.charAt(0).toUpperCase() + data?.OrderBy.slice(1);

  if (data?.search && !data?.OrderBy) {
    Optional = `?search=${data?.search}`;
  } else if (!data?.search && data?.OrderBy) {
    Optional = `?OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  } else if (data?.search && data?.OrderBy) {
    Optional = `?SearchBy=${data?.search}&OrderBy=${CapitalOrderBy}&orderDir=${data?.OrderDir}`;
  }

  return await axios.get(
    API_URL +
      `/api/ApplicantView/GetApplicants/${data?.pageSize}/${data?.pageNumber}${Optional}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchHappinessMeter = (data) => {
  return useQuery({
    queryKey: ["happinessMeter"],
    queryFn: () => fetchHappiness(data),
    enabled: true,
  });
};

const fetchSingleHappinessMeter = async (id) => {
  if (id) {
    return await axios.get(
      API_URL + `/api/ApplicantView/GetApplicantById?ApplicantId=${id}`,
      {
        headers: securityHeaders,
      }
    );
  }
};

const fetchHappiness = async () => {
  return await axios.get(API_URL + `/api/HappinessMeter/GetHappiness`, {
    headers: securityHeaders,
  });
};

export const useFetchSingleHappinessMeter = (id) => {
  return useQuery({
    queryKey: ["HappinessMeterbyId"],
    queryFn: () => fetchSingleHappinessMeter(id),
    enabled: true,
  });
};

/*****************fetch all Applicants */
const fetchApplicationNewsLetter = async (data) => {
  let url = `${API_URL}/api/News/GetNewsletterSubscriptions/${data?.pageSize}/${data?.pageNumber}`;

  const queryParams = [];
  if (data?.orderBy) queryParams.push(`OrderBy=${data.orderBy}`);
  if (data?.orderDir) queryParams.push(`orderDir=${data.orderDir}`);
  if (data?.search) queryParams.push(`SearchBy=${data.search}`);
  if (data?.filterByField && data?.filterBy)
    queryParams.push(`FilterByField=${data.filterByField}`);
  if (data?.filterBy) queryParams.push(`FitlerBy=${data.filterBy}`);

  if (queryParams.length > 0) {
    url += `?${queryParams.join("&")}`;
  }

  return await axios.get(url, {
    headers: securityHeaders,
  });
};

export const useFetchApplicationNewsLetter = (data) => {
  return useQuery({
    queryKey: ["applicationNewsletter"],
    queryFn: () => fetchApplicationNewsLetter(data),
    enabled: true,
  });
};

/***********Export table Applicants */
const exportTableHappinessMeter = async () => {
  return await axios.get(API_URL + "/api/Export/ExportHappinessMeter", {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportTableHappinessMeter = () => {
  return useMutation(() => exportTableHappinessMeter());
};
/***********Export table Applicants */

const exportTableApplicants = async () => {
  return await axios.get(API_URL + "/api/Export/ExportApplicants", {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportTableApplicants = () => {
  return useMutation(() => exportTableApplicants());
};
/***********Export table Applicants */
const exportTableLeads = async () => {
  return await axios.get(API_URL + "/api/Export/ExportShowingInterest", {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportTableLeads = () => {
  return useMutation(() => exportTableLeads());
};
/***********Export table Scholarship */
const exportTableScholarship = async () => {
  return await axios.get(API_URL + "/api/Export/ExportScholarshipApplicants", {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportTableScholarship = () => {
  return useMutation(() => exportTableScholarship());
};
/***********Export table Facility */
const exportTableFacility = async () => {
  return await axios.get(API_URL + "/api/Export/ExportFacilities", {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportTableFacility = () => {
  return useMutation(() => exportTableFacility());
};
/***********Export table Research */
// Moved off the shared `Export` controller and onto `Research` with the
// registry work, alongside `Research/Research` and `Research/ResearchDetails`.
// Both paths answer 401 to an unauthenticated caller — the auth middleware runs
// before routing — so a probe cannot tell which one exists; this is the path
// the backend team gave us.
/**
 * `ExportResearch` accepts the SAME filters as the list (minus pagination and
 * sort), so the spreadsheet matches what the operator is looking at. Exporting
 * everything while the screen shows a filtered subset is the kind of mismatch
 * nobody notices until the wrong file has been circulated.
 */
/**
 * A selection long enough that the URL becomes the risk rather than the
 * payload. Thirty-six characters per GUID plus `&Ids=`, and browsers and
 * proxies start truncating a little past 2000 — which fails as a 404 or a
 * silently short export rather than as an error anyone can read.
 */
const IDS_URL_LIMIT = 40;

const exportTableResearch = async ({ filters, ids, includeAttachments } = {}) => {
  // §A3: a selection and a filter are mutually exclusive. When the operator has
  // ticked specific rows that IS the request; re-applying the filters on top
  // could only ever remove rows they explicitly chose. The backend honours the
  // same rule — "a selection ignores the filters".
  const selected = Array.isArray(ids) && ids.length > 0;

  // The POST variant exists for exactly this, and takes the same shape:
  // `{ ids, includeAttachments }`.
  if (selected && ids.length > IDS_URL_LIMIT) {
    return await axios.post(
      API_URL + "/api/Research/ExportResearch",
      { ids, includeAttachments: Boolean(includeAttachments) },
      { headers: securityHeaders, responseType: "blob" }
    );
  }

  let query = selected
    ? buildIdsQuery(ids)
    : buildResearchQuery({
        ...(filters || {}),
        // Not accepted by the export endpoint; omitting them keeps the URL
        // honest about what it is asking for.
        SortBy: undefined,
        SortDirection: undefined,
      });

  // §A4: attachments ride along as a .zip instead of a bare .xlsx.
  if (includeAttachments) {
    query += `${query ? "&" : "?"}IncludeAttachments=true`;
  }

  return await axios.get(API_URL + `/api/Research/ExportResearch${query}`, {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportTableResearch = () => {
  return useMutation((options) => exportTableResearch(options));
};

/**
 * §A2 — one record, same column set as the table export.
 */
const exportSingleResearch = async ({ id, includeAttachments } = {}) => {
  const query = includeAttachments ? "?IncludeAttachments=true" : "";
  return await axios.get(
    API_URL + `/api/Research/ExportResearch/${id}${query}`,
    {
      headers: securityHeaders,
      responseType: "blob",
    }
  );
};
export const useExportSingleResearch = () => {
  return useMutation((options) => exportSingleResearch(options));
};

/**
 * §A1 — set a submission's status.
 *
 * `PATCH` rather than `PUT`: this changes one field and must not require the
 * caller to send back a whole record it might be holding a stale copy of.
 */
const setResearchStatus = async ({ id, status }) => {
  return await axios.patch(
    API_URL + `/api/Research/${id}/Status`,
    { status },
    { headers: securityHeaders }
  );
};
export const useSetResearchStatus = () => {
  return useMutation((payload) => setResearchStatus(payload));
};

/***********Export table Quizzes */
const exportTableQuizzes = async () => {
  return await axios.get(API_URL + "/api/Export/ExportQuizes", {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportTableQuizzes = () => {
  return useMutation(() => exportTableQuizzes());
};

/***********downloadAttachmentFile */

const downloadAttachmentFile = async (id) => {
  if (id) {
    return await axios.get(
      API_URL + `/api/ApplicantView/GetDocumentById/${id}`,
      {
        headers: securityHeaders,
        responseType: "blob",
      }
    );
  }
};

export const useDownloadAttachment = (id) => {
  return useMutation(downloadAttachmentFile);
};

/***********downloadAllAttachmentFiles */

const downloadAllAttachmentFiles = async (id1) => {
  if (id1) {
    return await axios.get(
      API_URL + `/api/ApplicantView/DownloadAllDocuments/${id1}`,
      {
        headers: securityHeaders,
        responseType: "blob",
      }
    );
  }
};

export const useDownloadAllAttachments = (id1) => {
  return useMutation(downloadAllAttachmentFiles);
};

/******************Download selected documents  */
const downloadSelectedDocuments = (values) => {
  return axios.post(
    API_URL + `/api/ApplicantView/DownloadSpecificDocuments`,
    values,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      ContentType: "application/json",
    }
  );
};

export const useDownloadSelectedDocuments = () => {
  return useMutation(downloadSelectedDocuments);
};
/*****************Delete File*/

const deleteFile = (id) => {
  return axios.post(
    API_URL + `/api/ApplicantView/DeleteApplicantFile/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useDeleteFile = () => {
  return useMutation(deleteFile);
};
